<!--
// add an is-phone check, hide if phone show if desktop //
<mat-paginator #paginator
  *ngIf="this.totalcount > 10"
  style-paginator
  [length]="this.totalcount"
  [pageSize]="this.pageSize"
  [pageSizeOptions]="[10,30,60,120]"
  (page)="getPaginatorData($event)"
  aria-label="Select page"
  showFirstLastButtons="false"
  hidePageSize = "false">
</mat-paginator>
-->

<div class="user-history-page">
  <div class="desktop-header-container">
    <h1 class="desktop-header-welcome">
      Welcome to Aviation Directory
    </h1>
  </div>
  <div class="form-container">
    <form [formGroup]="searchForm" [ngClass]="{'dialog-user-search-form': isDisplayingOnDialog}"
      (ngSubmit)="onSearch()" id="searchForm">
      <div class="desktopSearchStyles">
        <mat-form-field appearance="fill" class="userSearchInput">
          <mat-label>Name/Phone no#</mat-label>
          <input matInput type="text" formControlName='name' autofocus
            #nameSearch [matAutocomplete]="auto"
            placeholder="Start typing a name or phone no#"
            (input)="search(nameSearch.value)">
            <mat-autocomplete
              #auto="matAutocomplete" class="my-select-panel"
              (optionSelected)="onSuggestionChanged($event)">
              @for (_user of users$ | async; track _user) {
                <mat-option [value]="_user">
                  {{_user.firstName}} {{_user.lastName}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="desktopSearchStyles">
          <mat-form-field appearance="fill" class="userSearchInput">
            <mat-label>Division</mat-label>
            <mat-select formControlName="division" class="my-select-panel" (selectionChange)="onDivisionSelected($event.value)">
              <mat-option>--None--</mat-option>
              @for (division of divisions; track division) {
                <mat-option [value]="division.ID">
                  {{division.Name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (searchForm.controls['division'].value) {
            <mat-form-field appearance="fill" class="userSearchInput" floatLabel="auto">
              <mat-label>Section</mat-label>
              <mat-select formControlName="section" (selectionChange)="onSectionSelected($event.value)">
                @for (sect of sections; track sect) {
                  <mat-option [value]="sect.ID">
                    {{sect.Name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
        <!-- matTooltip="History For User" -->
        <div class="desktopSearchSubmit">
          <button type="submit" mat-raised-button class="regular-button" id="searchButton">
            Search <mat-icon>search</mat-icon>
          </button>
        </div>
      </form>
    </div>

    <div #searchresults class="user-history-container"
      [ngClass]="{'user-history-user-list': userList.length != 0}"
      >
      @if (loading) {
        <mat-spinner class="spinner" color="accent"></mat-spinner>
      }
      <ng-container>
        <div class="userList">
          @for (user of userList; track user) {
            <div class="user-history-user">
              <div class="user-history-user-profile" (click)="onUserSelect(user)">
                <div class="user-history-user-photo-container">
                  @if (user.photoSafe) {
                    <img
                      [src]="user.photoSafe"
                      alt="User Profile Picture"
                      class="user-profile-photo">
                  }
                  @if (!user.photoSafe) {
                    <img class="user-history-user-default-photo"
                      src="assets/images/logo_and_icons/empty_portrait_white_small.png"
                      alt="Empty Profile Picture">
                  }
                </div>
                <div class="user-history-user-desc">
                  <span class="user-history-user-name">{{ user.name }}</span>
                  <span class="user-history-user-title">{{ user.jobTitle }}</span>
                  <span class="user-history-user-division">{{ user.division }} - {{ user.section }}</span>
                </div>
              </div>
              @if (user.preferedContact || user.phone1 || user.email) {
                <div class="user-history-user-contact">
                  @if (user.preferedContact) {
                    <span class="user-history-user-contact-division user-history-search-contact-email" >
                      <mat-icon class="user-profile-contact-icon" color="primary">phone_in_talk</mat-icon>
                      <a href="tel:{{ user.preferedContact }}">{{user.preferedContact | phone}} </a>
                    </span>
                  }
                  @if (!user.preferedContact && user.phone1) {
                    <span class="user-history-user-contact-division user-history-search-contact-email" >
                      <mat-icon class="user-profile-contact-icon" color="primary">phone_in_talk</mat-icon>
                      <a href="tel:{{ user.phone1 }}">{{user.phone1 | phone}} </a>
                    </span>
                  }
                  @if (user.email) {
                    <span class="user-history-user-contact-division user-history-search-contact-email">
                      <mat-icon class="user-profile-contact-icon" color="primary">email</mat-icon>
                      <a href="mailto:{{user.email}}">{{user.email}}</a>
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </ng-container>
    </div>

  </div>
